
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-verified",
      function () {
        return require("private-next-pages/get-verified/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-verified"])
      });
    }
  